// extracted by mini-css-extract-plugin
export default {"cls1":"Avatar-cls1_B81","cls2":"Avatar-cls2_jqR Avatar-cls1_B81"};